<template>
    <div>
        <b-modal id="edit-custom-doc-employee-signature" title="Edit Employee Signature" scrollable hide-footer>
            <!-- we can add If users want to change some value here later -->
            <div class="form-group">
                <div v-for="key in count" :key="key">
                    <h2>Signature {{ key }}</h2>
                    <label for="page">page</label>
                    <input type="text" class="form-control" v-model="values['page' + key]" />
                    <label for="xpos">Xpos</label>
                    <input type="text" class="form-control" v-model="values['xpos' + key]" />
                    <label for="ypos">Ypos</label>
                    <input type="text" class="form-control" v-model="values['ypos' + key]" />
                    <label for="xoff">Xoff</label>
                    <input type="text" class="form-control" v-model="values['xoff' + key]" />
                    <label for="yoff">Yoff</label>
                    <input type="text" class="form-control" v-model="values['yoff' + key]" />
                </div>
                <b-button id="add_more_fields" @click="add"> Add</b-button>
                <b-button id="remove_fields" @click="remove"> Remove</b-button>
            </div>
            <div class="newUserButtonContainer">
                <b-button @click="closeModal('edit-custom-doc-employee-signature')">Cancel</b-button>
                <b-button @click="saveCustomDocEmployeeSignature">Edit</b-button>
            </div>
        </b-modal>
    </div>
</template>

<style scoped>
.newUserButtonContainer {
    display: flex;
    justify-content: space-between;
}
</style>

<script>
import Vue from 'vue'
// resources
import CustomDocResource from '../../resources/custom_doc'
// mixins
import modalMixin from '../../mixins/modal'
import toastMixin from '../../mixins/toast'

export default Vue.extend({
    props: {
        resource: {
            required: false,
            type: Object,
            default: () => {
                return null
            },
        },
    },
    data() {
        return {
            count: 1,
            customDocResource: null,
            isSaving: false,
            values: {},
        }
    },
    watch: {
        resource(newValue) {
            this.setInitialValues(newValue)
        },
    },
    mixins: [modalMixin, toastMixin],
    methods: {
        add: function() {
            this.count++
        },
        remove: function() {
            delete this.values['page' + this.count]
            delete this.values['xpos' + this.count]
            delete this.values['ypos' + this.count]
            delete this.values['xoff' + this.count]
            delete this.values['yoff' + this.count]
            this.count--
        },
        setInitialValues(data) {
            if (data) {
                this.values = {}
                let employeeSignatures = data.attributes.properties.employee_signature
                let employeeSignaturesLength = employeeSignatures.length
                if (employeeSignaturesLength > 0) {
                    let idx = 1
                    this.count = employeeSignaturesLength
                    for (let employeeSignature of employeeSignatures) {
                        this.values['page' + idx] = employeeSignature.page
                        this.values['xpos' + idx] = employeeSignature.xpos
                        this.values['ypos' + idx] = employeeSignature.ypos
                        this.values['xoff' + idx] = employeeSignature.xoff
                        this.values['yoff' + idx] = employeeSignature.yoff
                        if (employeeSignaturesLength == idx) break
                        idx++
                    }
                }
            }
        },
        async saveCustomDocEmployeeSignature() {
            let resArray = []
            for (let i = 1; i <= this.count; i++) {
                let obj = {}
                if (this.values['page' + i] != undefined) obj.page = Number(this.values['page' + i])
                if (this.values['xpos' + i] != undefined) obj.xpos = Number(this.values['xpos' + i])
                if (this.values['ypos' + i] != undefined) obj.ypos = Number(this.values['ypos' + i])
                if (this.values['xoff' + i] != undefined) obj.xoff = Number(this.values['xoff' + i])
                if (this.values['yoff' + i] != undefined) obj.yoff = Number(this.values['yoff' + i])
                if (Object.keys(obj).length) resArray.push(obj)
            }

            let properties = this.resource.get('properties')
            properties.employee_signature = resArray

            this.resource.set('properties', JSON.stringify(properties))
            let errors = this.resource.validate()

            if (errors.length) {
                this.handleErrors(errors)
            } else {
                try {
                    this.isSaving = true
                    const result = await this.resource.save()
                    if (result.response.status === 200 || result.response.status === 201) {
                        this.createToast('b-toaster-top-center', 'success', true, 'Custom Document Location Edited', '')
                        this.closeModal('edit-custom-doc-employee-signature')
                    }
                } catch (error) {
                    this.createToast('b-toaster-top-center', 'danger', true, 'Custom Document Edit Error', 'Error')
                    throw error
                }
                this.isSaving = false
            }
        },
    },
    computed: {
        resources() {
            return {
                CustomDocResource,
            }
        },
    },
})
</script>
